export default __webpack_public_path__ + "static/media/bell.8c40b861.svg";